import { PulseStateModel } from 'ng2-app/models/pulse/pulse-state.model';
import { PulseHistoricalParams } from 'ng2-app/models/pulse/pulse.type';

/**
 * Get Scoring Groups for a specific lender user
 */
export class GetScoringGroupsByLenderUserId {
  static readonly type = '[Pulse] GetScoringGroupsByLenderUserId';
  constructor(
    public lenderUserId: number,
    public patch: keyof Pick<PulseStateModel, 'primaryScoringGroups' | 'secondaryScoringGroups'> = 'primaryScoringGroups',
    public overrideCache = false
  ) {}
}

/**
 * Get All Scoring Groups
 */
export class GetAllScoringGroups {
  static readonly type = '[Pulse] GetAllScoringGroups';
  constructor(public overrideCache = false) {}
}

/**
 * Get Scores for a lender user
 */
export class GetScoresByLenderUserId {
  static readonly type = '[Pulse] GetScoresByLenderUserId';
  constructor(public lenderUserId: number, public overrideCache = false, public historicalParams?: PulseHistoricalParams) {}
}

/**
 * Get Scores for a team
 */
export class GetScoresByTeamId {
  static readonly type = '[Pulse] GetScoresByTeamId';
  constructor(public teamId: number, public overrideCache = false, public historicalParams?: PulseHistoricalParams) {}
}

/**
 * Get Real Time Scores for a team
 */
export class GetRealTimeScoresByTeamId {
  static readonly type = '[Pulse] GetRealTimeScoresByTeamId';
  constructor(public teamId: number, public overrideCache = false) {}
}

/**
 * Get Scores for a scoring group
 */
export class GetScoresByScoringGroupId {
  static readonly type = '[Pulse] GetScoresByScoringGroupId';
  constructor(public scoringGroupId: number, public overrideCache = false) {}
}

/**
 * Get Real Time Scores for a scoring group
 */
export class GetRealTimeScoresByScoringGroupId {
  static readonly type = '[Pulse] GetRealTimeScoresByScoringGroupId';
  constructor(public scoringGroupId: number, public overrideCache = false) {}
}

/**
 * Get Historical Scores for a scoring group
 */
export class GetHistoricalScoresByScoringGroupId {
  static readonly type = '[Pulse] GetHistoricalScoresByScoringGroupId';
  constructor(public scoringGroupId: number, public overrideCache = false) {}
}

/**
 * Get Teams with Scoring Groups
 */
export class GetTeamsWithScoringGroups {
  static readonly type = '[Pulse] GetTeamsWithScoringGroups';
  constructor(public includeZeroMemberTeams = false, public overrideCache = false) {}
}

/**
 * Get Lender Users with Scoring Groups
 */
export class GetLenderUsersWithScoringGroups {
  static readonly type = '[Pulse] GetLenderUsersWithScoringGroups';
  constructor(public overrideCache = false) {}
}

/**
 * Fetch historical scores for a single scoring group for a lender user
 * and store the result as an override (only updates the targeted group)
 */
export class GetHistoricalScoresByGroupForUser {
  static readonly type = '[Pulse] GetHistoricalScoresByGroupForUser';
  constructor(
    public lenderUserId: number,
    public scoringGroupId: number,
    public historicalParams?: PulseHistoricalParams
  ) {}
}
